import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';

import user from './common/user';
import settings from './common/settings';
import notifications from './common/notifications';
import channelDetail from './common/channelDetail';
import operatorDashboard from './operator/dashboard';
import websocket from './common/websocket';

const reducers = {
  routing: routerReducer,
  user,
  settings,
  notifications,
  channelDetail,
  operatorDashboard,
  websocket,
};

module.exports = combineReducers( reducers );



// WEBPACK FOOTER //
// ./stores/reducers/index.js